import React from 'react';
import InteractiveLearning from './InteractiveLearning';
import SectionBlock from './SectionBlock';
import GalleryBlock from './GalleryBlock';
import QuickLinks from './QuickLinks';

const BlockFactory = ({ blocks }) => {
  //   console.log(blocks);

  if (!blocks) return null;

  return blocks.map((block) => {
    switch (block.__typename) {
      case 'DatoCmsSectionBlock':
        return <SectionBlock key={block.id} block={block} />;
      case 'DatoCmsInteractiveLearning':
        return <InteractiveLearning key={block.id} block={block} />;
      case 'DatoCmsGalleryBlock':
        return <GalleryBlock key={block.id} block={block} />;
      case 'DatoCmsQuickLinks':
        return <QuickLinks key={block.id} block={block} />;
      default:
        console.log(`Couldn't find a block for ${block.__typename}`);
        return null;
    }
  });
};

export default BlockFactory;
